<template>
  <section>
    <h1 class="title is-4">Historial de cargas</h1>
    <div class="columns">
      <!-- Text Filter -->
      <div class="column is-4">
        <b-field label="Filtrar" label-position="on-border">
          <b-input
            v-model.trim="query"
            placeholder="Buscar por UUID u hospital"
            icon="search"
            :disabled="loading"
            @input="onFilterChange"
          />
        </b-field>
      </div>

      <div class="column is-2">
        <b-field label="Resultados por pagina">
          <b-select v-model.number="perPage" expanded :disabled="loading" @input="onPerPageChange">
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
          </b-select>
        </b-field>
      </div>

      <div class="column is-2 is-offset-4">
        <router-link to="create">
          <a class="button is-primary">Nueva importación</a>
        </router-link>
      </div>


    </div>

    <!-- Table -->
    <div class="table-container">
      <b-table
        :data="rows"
        :loading="loading"
        :paginated="true"
        :backend-pagination="true"
        :total="total"
        :per-page="perPage"
        :current-page.sync="page"
        :striped="true"
        :hoverable="true"
        :mobile-cards="true"
        @page-change="onPageChange"
      >
        <template #empty>
          <section class="section has-text-centered">
            <p v-if="!loading">Sin resultados para el filtro actual</p>
          </section>
        </template>

        <b-table-column field="uuid" label="UUID" width="260" v-slot="props">
          <router-link :to="{name: 'sedena-import-show', params: {uuid: props.row.uuid}}">{{ props.row.uuid }}</router-link>
        </b-table-column>

        <b-table-column field="hospital" label="Hospital" v-slot="props">
          {{ props.row.company.code }} - {{ props.row.company.name }}
        </b-table-column>

        <b-table-column field="date" label="Fecha" v-slot="props">
          {{ props.row.date }}
        </b-table-column>

        <b-table-column field="performedBy" label="Usuario" v-slot="props">
          {{ props.row.user.id }} - {{ props.row.user.name }}
        </b-table-column>

        <b-table-column field="created_at" label="Fecha Registro" v-slot="props">
          {{ formatDate(props.row.created_at) }}
        </b-table-column>
      </b-table>
    </div>
  </section>
</template>

<script>
export default {
  name: "ImportIndex",
  components: {},
  data() {
    return {
      query: "",
      page: 1,
      perPage: 10,
      total: 0,
      rows: [],
      loading: false,
      _debounceId: null,
      companies: [],
    };
  },
  computed: {},
  mounted() {
    this.wrapper = document.getElementById('main-wrapper');
    this.wrapper.classList.add('is-expanded');
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      const params = {
        page: this.page,
        per_page: this.perPage,
        query: this.query.trim() || '',
      }
      this.$http.get('sedena/work', {
        params
      }).then(({data}) => {
        this.rows = data.data;
        this.total = data.meta.total;
      }).catch(error => {
        this.$alfalab.showError(error)
      }).finally(() => {
        this.loading = false;
      })
    },
    onFilterChange() {
// Debounce to avoid hitting the backend on every keystroke
      clearTimeout(this._debounceId);
      this._debounceId = setTimeout(() => {
        this.page = 1; // reset to first page when filter changes
        this.fetchData();
      }, 400);
    },
    onPageChange(newPage) {
      this.page = newPage;
      this.fetchData();
    },
    onPerPageChange() {
      this.page = 1;
      this.fetchData();
    },
    formatDate(val) {
      if (!val) return "—";
      const d = new Date(val);
      if (isNaN(d.getTime())) return String(val);
// Example: 2025-08-26 14:05
      const pad = n => String(n).padStart(2, "0");
      const yyyy = d.getFullYear();
      const mm = pad(d.getMonth() + 1);
      const dd = pad(d.getDate());
      const hh = pad(d.getHours());
      const min = pad(d.getMinutes());
      return `${yyyy}-${mm}-${dd} ${hh}:${min}`;
    }
  }
};
</script>

<style scoped>

</style>